import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TextInput from "../../components/ReactHookForm/TextInput";
import { Button, Form } from "react-bootstrap";
import MuniSpinner from "../../components/MuniSpinner";
import { generarCedulaDeNotificacion, generarCedulaSchema } from "./handlers";

const FormGenerarCedula = (props) => {
  const { acta, setActa, setModalGenerarCedulaIsOpen } = props;
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty, dirtyFields },
  } = useForm({
    resolver: yupResolver(generarCedulaSchema),
    defaultValues: {
      id_acta: acta.id,
      nombre_completo: "",
      domicilio_completo: "",
      numero_documento: "",
    },
  });

  return (
    <Form onSubmit={handleSubmit((data) => generarCedulaDeNotificacion(data, acta, setActa, setIsLoading))}>
      <p className='fw-semibold'>Completar con los datos de la persona a la cuál se notifica</p>
      <fieldset disabled={isLoading}>
        <TextInput
          name='nombre_completo'
          label='Nombre completo *'
          register={register}
          errors={errors?.nombre_completo}
          className='h-full'
        />

        <TextInput
          name='numero_de_documento'
          label='Documento *'
          type='number'
          register={register}
          errors={errors?.numero_de_documento}
          className='h-full'
        />

        <TextInput
          name='domicilio_completo'
          label='Domicilio completo *'
          register={register}
          errors={errors?.domicilio_completo}
          className='h-full'
        />

        <div className='d-flex justify-content-start'>
          <div className='d-flex flex-wrap gap-2'>
            <Button type='submit' disabled={Object.keys(dirtyFields).length !== 3}>
              {isSubmitting ? (
                <div className='d-flex gap-1'>
                  <MuniSpinner
                    width='18px'
                    height='18px'
                    circularProgressSize={24}
                    circularProgressColor='#ffffff'
                    fileName='bola-blanca.png'
                  />
                  Generando
                </div>
              ) : (
                "Generar"
              )}
            </Button>
            <Button variant='danger' onClick={() => setModalGenerarCedulaIsOpen(false)}>
              Cancelar
            </Button>
          </div>
        </div>
      </fieldset>
    </Form>
  );
};

export default FormGenerarCedula;
